<template>
  <div class="segment header-segment">
    <div class="container">
      <router-link :to="{ name: 'start' }">
        <div class="logo">{{ $t('page.company') }}</div>
        <div class="claim">{{ $t('page.claim') }}</div>
      </router-link>
      <div class="product">
        <div class="brand">{{ $t('page.brand') }}</div>
        <div class="service">{{ $t('page.service') }}</div>
      </div>
      <div class="toolbar">
        <icon-button
          icon="tk_icon_customize"
          class="is-white"
          v-if="$route.name === 'calculator'"
          v-on:click.native="onClickCustomize">
        </icon-button>
        <icon-button
          icon="tk_icon_menu"
          class="is-white"
          v-on:click.native="onClickMenu">
        </icon-button>
      </div>
    </div>
  </div>
</template>

<script>
import fn from '../../services/GlobalService'
import Bus from '../../services/EventService'

export default {
  name: 'header-segment',
  methods: {
    onClickMenu () {
      Bus.fire('global/show-navigation-menu')
    },
    onClickCustomize () {
      Bus.fire('global/show-input-menu')
    }
  }
}
</script>

<style lang="sass">
.header-segment
  position: relative
  width: 100%
  padding: 0.7rem 0
  background-color: $primary
  color: $text-invert
  z-index: $z-index-header

  .container
    position: relative
    height: ($toolbar-height-mobile - 1.4rem)
    transition: height .5s ease

    .logo
      position: absolute
      display: block
      top: 0.6rem
      left: $content-padding-mobile
      width: 11rem
      height: 2rem
      color: $primary-invert
      text-indent: -9999em
      overflow: hidden
      background: url(/assets/logos/tk_logo_mobile.svg) no-repeat

    .claim
      display: none

    .product
      display: none

    .toolbar
      position: absolute
      right: $content-padding-mobile

+tablet

  .header-segment
    padding: 1.5rem 0 1.3rem 0

    .container
      height: 4.4rem
      transition: height .5s ease

      .logo
        top: auto
        left: $content-padding-desktop
        bottom: 0
        width: 5.68rem
        height: 4.4rem
        background: url(/assets/logos/tk_logo_desktop.svg) no-repeat

      .claim
        position: absolute
        display: block
        bottom: 0
        left: 9.5rem
        width: 13.68rem
        height: 1rem
        color: $primary-invert
        text-indent: -9999rem
        overflow: hidden
        background: url(/assets/logos/tk_claim_desktop.svg) no-repeat

      .product
        position: absolute
        display: inline
        right: $content-padding-desktop
        bottom: 0
        font-size: $size-4

        .brand
          line-height: 1
          text-align: right

        .service
          text-align: right
          margin-top: 0.25rem
          line-height: 1

      .toolbar
        display: none

+desktop

  .header-segment
    padding: 1.9rem 0 1.6rem 0

    .container
      height: 5.5rem

      .logo
        width: 7.1rem
        height: 5.5rem

      .claim
        left: 11.9rem
        width: 17.1rem
        height: 1.25rem

      .product
        font-size: $size-3

        .brand

        .service

      .toolbar

</style>



// WEBPACK FOOTER //
// src/views/segments/HeaderSegment.vue